import { render, staticRenderFns } from "./AssignedStudent.vue?vue&type=template&id=edbb03da&"
import script from "./AssignedStudent.vue?vue&type=script&lang=js&"
export * from "./AssignedStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports